import styles from "./ua.module.scss";

export default function FormCell(props) {
  return <div className={ styles.cell + ' ' + styles['cell' + props.size] }>{ props.children }</div>
}
